import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { LeaveRow } from './leave-row';
import { ILeave } from '../types';
import { useAuthRole } from '@app/utils';

interface Props {
  tableProps: TableProps;
  rows?: ILeave[];
  loading: boolean;
  itSelf: boolean;
}

const LeaveTable = ({ tableProps, rows, loading, itSelf }: Props) => {
  const { isSuperAdmin, isManager } = useAuthRole();

  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    ...(isManager || isSuperAdmin
      ? [{ id: 'name', label: 'Employee', align: 'center', sortable: false }]
      : []),
    ...(isSuperAdmin
      ? [{ id: 'manager', label: 'Manager', align: 'center', sortable: false }]
      : []),
    { id: 'leave', label: 'Leave Type', align: 'center', sortable: false },
    { id: 'from', label: 'From', align: 'center' },
    { id: 'to', label: 'To', align: 'center' },
    { id: 'reasonForLeave', label: 'Reason For Leave', align: 'left', sortable: false },
    ...(isSuperAdmin || (isManager && !itSelf)
      ? [{ id: 'request', label: 'Request', align: 'center', sortable: false }]
      : []),
    { id: 'reasonForDecline', label: 'Reason For Decline', align: 'center', sortable: false },
    { id: 'status', label: 'Status', align: 'center', sortable: false },
    { id: 'updatedBy', label: 'Updated By', align: 'center', sortable: false },
    ...(!isSuperAdmin && itSelf
      ? [{ id: 'action', label: 'Action', align: 'center', sortable: false }]
      : []),
  ];

  return (
    <PaginatedTable<ILeave>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <LeaveRow
          row={row}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
          itSelf={itSelf}
        />
      )}
    </PaginatedTable>
  );
};

export { LeaveTable };
